import React from "react";
import { baseS3URL } from "src/lib/environment";

const EngineLogo = () => <img src={baseS3URL + "/assets/hEngine.png"} />;
export default EngineLogo;
